<template>
    <div class="newsRight">
        <div class="curmbsLink">
            <router-link to="/">首页</router-link>
            <span> > </span>
            <router-link to="/news/industry-news">行业新闻</router-link>
            <span> > </span>
            <span>新闻详情</span>
        </div>
        <div class="newDetailImage">
            <img src="../assets/images/write.png" alt="">
        </div>
        <div class="newDetailTitle">
            <div class="mouth"><span>12</span><i>七月</i></div>
            <div class="textTitle">
                <span>葡萄酒跨境电商交易；关税豁免；深圳鼎付暂停收款；eBay推品牌线上直销店；Wish:EPC新增意大利测试路向……</span>
                <p>湖北首家依托一带一路、中欧班列打造的葡萄酒保税仓10日举行开仓仪式。后期，该省将依托汉欧班列与武汉法国葡萄酒保税仓。</p>
                <div>
                    <a href="javascript:;">
                        <img src="../assets/images/share.png" alt="">
                        <span>打印</span>
                    </a>
                    <a href="javascript:;">
                        <img src="../assets/images/share.png" alt="">
                        <span>分享</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="newDescriptionDetail">
            <span>湖北依托中欧班列建设葡萄酒跨境电商交易平台</span>
            <p>
                湖北首家依托一带一路、中欧班列打造的葡萄酒保税仓10日举行开仓仪式。后期，该省将依托汉欧班列与武汉法国葡萄酒保税仓，建设葡萄酒跨境电商B2B交易平台。武汉法国葡萄酒保税仓目前已建设完毕，里面现有法国各名庄红葡萄酒系列、德国红葡萄酒、德国雷司令白葡萄酒等，计划于2019年7月初投入使用。
            </p>

            <span>重磅利好！超100种中国产品高额关税获得豁免</span>
            <p>
                据路透社美国时间7月10日凌晨的报道，美国政府宣布将豁免110种中国制造的产品，其中包括医疗器材、电容原件等，这些产品可以免受美国政府在一年前，即2018年7月6日对价值340亿美元中国产品所加征的25%关税。豁免从即日起生效，时间为一年。
            </p>

            <span>深圳鼎付暂停收款服务</span>
            <p>
                众所周知，今年的PrimeDay狂欢节将于7月15日正式拉开帷幕，翘首盼望的爆单脚步即将来临之时，深圳鼎付（英文名Gleebill）收款平台在7月15日之后将不再提供亚马逊欧元、英镑、日元店铺的收款服务。卖家需要在7月15日之前及时更换亚马逊欧洲、英国、日本店铺的Gleebill收款账号。7月15日之后收到的亚马逊款项将原路返回亚马逊，亚马逊下次放款的时候重新放款给卖家新的收款账号。
            </p>

            <span>eBay推品牌线上直销店</span>
            <p>eBay日前宣布将在eBay.com/BrandOutlet上为各大品牌推出线上直销店Summer Brand Outlet，并为该网站购买的商品提供快速免费送货服务。</p>
            <p>据eBay美国平台的负责人表示，新的直销店可以为eBay买家提供大幅折扣，包括阿迪达斯、Bose、新秀丽、雷朋、Michael Kors和劳力士等品牌。</p>

            <span>Wish：EPC新增意大利测试路向</span>
            <p>
                自7月18日早10时起，EPC项目将新增测试路向：意大利。该变更将影响2019年7月18日早10时（北京时间）后发布的订单，该时间之前发布的订单将不会受到影响。据了解，目前正在参加EPC服务且选品生效的商品于2019年7月18日早10时后发布的意大利路向订单将被合并。商户必须使用Wish邮EPC物流渠道来履行这些合并订单。
            </p>
            <b>以上信息来源于网络</b>
        </div>
    </div>
</template>

<style lang="scss">
    .newsRight {
        padding-left: 30px;
        flex: 1;
        .curmbsLink {
            width: 100%;
            line-height: 30px;
            margin-bottom: 20px;
            a { color: rgba(50,50,50, 0.3); }
            a:hover { color: #323232; }
        }
        .newDetailImage {
            padding-top: 20px;
            margin: 40px 0;
            border-top: 1px solid #ddd;
            width: 100%;
            img { width: 100%; height: auto; display: block;}
        }
        .newDetailTitle {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;
            .mouth {
                width: 100px;
                height: 120px;
                background: rgba(18, 10, 76, .4);
                display: flex;
                flex-flow: column nowrap;
                justify-content: center;
                align-items: center;
                color: #fff;
                span {
                    display: block;
                    margin-bottom: 10px;
                    font-size: 30px;
                    font-weight: 900;
                }
                i {font-size: 16px;}
            }
            .textTitle {
                flex: 1;
                padding-left: 30px;
                display: flex;
                flex-flow: column nowrap;
                justify-content: center;
                align-items: flex-start;
                span {
                    display: block;
                    font-size:24px;
                    font-weight: bold;
                    margin-bottom: 15px;
                }
                p {
                    display: block;
                    color:rgba(50, 50, 50, .5);
                    font-size: 16px;
                    margin-bottom: 20px;
                }
                div {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: flex-start;
                    align-items: center;
                    a {
                        display: flex;
                        flex-flow: row nowrap;
                        justify-content: center;
                        align-items: flex-start;
                        margin-right: 20px;
                        img {
                            display: block;
                            width: 16px;
                            height: 16px;
                            margin-right: 15px;
                        }
                        span { font-size: 16px; margin: 0; }
                    }
                }
            }
        }
        .newDescriptionDetail {
            font-size: 14px;
            span {
                font-size: 16px;
                display: block;
                margin-bottom:10px;
            }
            p {
                color: #555;
                line-height: 34px;
                margin-bottom: 20px;
            }
        }
    }
</style>


<script>
import store from '../vuex'
// import Child from '../components/Child.vue'
export default {
  data() {
      return {
        bannerObj: {
            imgUrl: require('../assets/images/news.png'),
            text: 'NEWS',
        }
      }
  },
  store,
}
</script>

